"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dimensionsFromImageUrl = exports.decodeImageUrl = void 0;

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.string.match.js");

const IMAGE_URL_DIMENSIONS_REGEX = new RegExp("/rs:(?<resizingType>[^:]+):(?<width>[0-9]+):(?<height>[0-9]+):(?<enlarge>[0-9]+)/");

const decodeImageUrl = url => {
  const addr = new URL(url);
  const path = addr.pathname;
  const matchResult = path.match(IMAGE_URL_DIMENSIONS_REGEX);
  return matchResult.groups;
};

exports.decodeImageUrl = decodeImageUrl;

const dimensionsFromImageUrl = url => {
  const {
    width,
    height,
    resizingType
  } = decodeImageUrl(url);

  if (resizingType === 'fill') {
    return {
      width,
      height
    };
  } else {
    return {};
  }
};

exports.dimensionsFromImageUrl = dimensionsFromImageUrl;